// Trae las plantas de la cuenta por el puerto (sites/port.ts) y las deja en
// el estado que la pantalla sabe pintar (logic/sites.ts). Sin polling: la
// lista cambia cuando UCORP habilita o deshabilita a la empresa en una
// planta, no minuto a minuto.
import { useEffect, useState } from "react";
import type { PortalSession } from "../auth/session.js";
import { estadoDesdeContexto, type EstadoDePlantas } from "../logic/sites.js";
import { SitesAccessError, type SitesPort } from "./port.js";

export function usePlantas(port: SitesPort, session: PortalSession): EstadoDePlantas {
  const [estado, setEstado] = useState<EstadoDePlantas>({ estado: "cargando" });

  useEffect(() => {
    let vigente = true;
    setEstado({ estado: "cargando" });
    port
      .list(session)
      .then((contexto) => {
        if (vigente) setEstado(estadoDesdeContexto(contexto));
      })
      .catch((error: unknown) => {
        // Sin el error al estado ni al log: puede traer datos de la cuenta.
        if (vigente) setEstado({ estado: error instanceof SitesAccessError ? "denegado" : "error" });
      });
    return () => {
      vigente = false;
    };
  }, [port, session]);

  return estado;
}
